<template>
    <div class="page">
        <el-dialog :title="title" :visible.sync="showDialog" width="950px">
            <el-form :model="rulesInfo" label-width="150px" :rules="rules" ref="form">
                <el-form-item label="分账规则名称" prop="ruleName">
                    <div class="item-info">
                        <el-input class="w-400" v-model="rulesInfo.ruleName" placeholder="请输入分账规则名称" />
                        <span>给您的分账规则起名，方便查找，可使用字母、文字、数字组合，名称不可重复</span>
                    </div>
                </el-form-item>
                <!-- <el-form-item label="分账渠道" prop="split_channel">
          <div class="item-info">
            <el-select class="w-400" v-model="rulesInfo.split_channel" placeholder="请选择分账渠道">
              <el-option v-for="item in channelList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <span>根据支付渠道确定对应的分账渠道</span>
          </div>
        </el-form-item>
        <el-form-item label="主商户名称" prop="main_merchant">
          <el-select
            class="w-400"
            v-model="rulesInfo.main_merchant"
            placeholder="主商户名称会根据分账渠道默认，若不对请选择"
          >
            <el-option v-for="item in merchantList" :key="item.value" :label="item.label" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="主商户号"> -->
                <!-- 主商户号直接从主商户信息里取就行了，这里做个样子 -->
                <!-- <el-input
            disabled
            class="w-400"
            v-model="rulesInfo.main_merchant.id"
            placeholder="主商户号会根据商户名称自动带出"
          />
        </el-form-item> -->
                <el-form-item label="是否启用规则" prop="startType">
                    <el-radio label="1" v-model="rulesInfo.startType">启用</el-radio>
                    <el-radio label="2" v-model="rulesInfo.startType">暂不启用</el-radio>
                </el-form-item>
                <el-form-item label="规则内容" required>
                    <el-button class="add-btn" icon="el-icon-plus" @click="addRule">添加</el-button>
                </el-form-item>
            </el-form>
            <div class="table-box">
                <el-table :data="rulesInfo.rulesReqVOList" max-height="300px">
                    <el-table-column label="商户名称" width="200px" header-align="center" align="center">
                        <div slot-scope="scope">
                            <el-select v-model="scope.row.accountName" @change="bindChange">
                                <el-option v-for="(item,index) in bindList" :label="item.accountName" :value="item.accountName" :key="index" />
                            </el-select>
                        </div>
                    </el-table-column>
                    <el-table-column label="分润比" width="180px" header-align="center" align="center">
                        <div slot-scope="scope" class="item-info">
                            <el-input type="number" v-model="scope.row.shareProfit" placeholder="请输入0~100" />
                            <div class="m-l-5">%</div>
                        </div>
                    </el-table-column>
                    <el-table-column label="分账渠道" header-align="center" align="center">
                        <div slot-scope="scope">{{ scope.row.channel}}</div>
                    </el-table-column>
                    <el-table-column label="商户号/登录号" header-align="center" align="center">
                        <div slot-scope="scope">{{ scope.row.accountId}}</div>
                    </el-table-column>
                    <el-table-column label="操作" width="100px" header-align="center" align="center">
                        <span class="delete-btn" slot-scope="scope" @click="deleteRule(scope)">删除</span>
                    </el-table-column>
                </el-table>
            </div>
            <div class="bottom-btn">
                <el-button type="primary" @click="validateForm">保存</el-button>
                <el-button @click="showDialog = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'AddRule',
  inject: ['app_type'],
  props: ['id'],
  data() {
    return {
      title: '',
      showDialog: false,
      // channelList: [
      //   {
      //     label: '微信',
      //     value: 1,
      //   },
      //   {
      //     label: '支付宝',
      //     value: 2,
      //   },
      //   {
      //     label: '银联',
      //     value: 3,
      //   },
      // ],
      // merchantList: [
      //   {
      //     label: '洛阳市中心医院',
      //     value: 1,
      //     id: '1',
      //   },
      //   {
      //     label: '洛阳军区总院',
      //     value: 2,
      //     id: '2',
      //   },
      //   {
      //     label: '洛阳人民医院',
      //     value: 3,
      //     id: '3',
      //   },
      // ],
      // rulesInfo: {
      //   // main_merchant: {},
      //   rulesReqVOList: [],
      //   startType: '2',
      //   mainMerchantName: JSON.parse(localStorage.getItem('checkdApply')).applyName, //主商户名称-应用名称（默认回显）
      //   mainMerchant:JSON.parse(localStorage.getItem('merchantInfo')).hyUid
      // },
      rules: {
        ruleName: { required: true, message: '请输入分账规则名称', trigger: 'blur' },
        split_channel: { required: true, message: '请选择分账渠道', trigger: 'blur' },
        main_merchant: {
          required: true,
          message: '请选择主商户',
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (!value.id) {
              callback(new Error('请选择主商户'));
            } else {
              callback();
            }
          },
        },
        startType: { required: true, message: '请选择是否启用规则', trigger: 'blur' },
      },
    };
  },
  computed: {
    ...mapState({
      bindList: (state) => state.rules.bindList,
      rulesInfo: (state) => state.rules.rulesInfo,
    }),
  },
  mounted() {
    this.getBindList({ merchant: JSON.parse(localStorage.getItem('merchantInfo')).hyUid });
  },
  methods: {
    ...mapActions('rules', ['getBindList', 'saveRules','getRulesAll','queryRule','updateRule']),
    // 如果clear的话，就清空（两次点击同一个的话就不清空了，否则清空）
    async openDialog() {
      if (this.id) {
        console.log('如果有id的话就是修改，要调接口');
        this.title = '修改分账规则';
        await this.queryRule({ruleId:this.id})
      } else {
        this.rulesInfo.ruleName="";
        this.rulesInfo.startType='2';
        this.rulesInfo.rulesReqVOList=[];
        this.title = '添加分账规则';
      }
      this.showDialog = true;
    },
    //选中的值发生变化
    bindChange(e) {
      this.bindList.map((item) => {
        if(e===item.accountName){
          this.rulesInfo.rulesReqVOList.forEach((m) => {
            if (e === m.accountName) {
              m.channel = item.channel;
              m.accountId=item.accountId;
            }
          });
        }
      });
    },
    addRule() {
      this.rulesInfo.rulesReqVOList.push({});
    },
    deleteRule(scope) {
      this.rulesInfo.rulesReqVOList.splice(scope.$index, 1);
    },
    validateForm() {
      // this.$refs.form.validate((valid) => {
      //   if (valid) {
      //     let sum = 0;
      //     let msg = '';
          // 下面是判断分润比是否正确的，hospital是用于判断医院是否有重复
          // let hospital = new Set();
          // this.rulesInfo.rulesReqVOList.forEach((v) => {
          //   sum = sum + Number(v.shareProfit);
          //   if (v.shareProfit === '' || v.shareProfit === undefined) {
          //     msg = '分润比不能为空';
          //   }
          //   if (v.shareProfit > 30) {
          //     msg = '单商户的分润比不能超过30%';
          //   }
          //   if (v.shareProfit < 0) {
          //     msg = '分润比不能为负数';
          //   }
          //   if (!v.merchant || !v.merchant.id) {
          //     msg = '规则内容中商户不能为空';
          //   } else {
              // 这是为了判断规则中的医院是否有重复，需要用到唯一的id做判断，可根据后端返回改变字段，只要唯一即可
          //     hospital.add(v.merchant.id);
          //   }
          // });
          // if (!msg) {
          //   if (sum > 30) {
          //     msg = '百分比总和超过30%，请重新输入';
          //   }
          //   if (sum < 30) {
          //     msg = '百分比总和不足30%，请重新输入';
          //   }
          //   if (this.rulesInfo.rulesReqVOList.length == 0) {
          //     msg = '请至少添加一条规则';
          //   }
          // }
          // if (!msg && hospital.size < this.rulesInfo.rulesReqVOList.length) {
          //   msg = '规则内容中的商户不能重复';
          // }
          // if (msg) {
          //   this.$message({
          //     message: msg,
          //     type: 'error',
          //   });
          // } else {
            if(this.id){  //id存在为修改
              this.updateRule(this.rulesInfo).then(()=>{
                  this.$message.success('分账规则修改成功');
                  this.showDialog = false;
                  this.getRulesAll({ mainMerchant: JSON.parse(localStorage.getItem('merchantInfo')).hyUid });
              }).catch((err) => {
                  this.$message.error(err.msg);
              });
            }else{   //不存在为新增
              this.rulesInfo.mainMerchant=localStorage.getItem('merchantInfo')?JSON.parse(localStorage.getItem('merchantInfo')).hyUid:'';
              this.rulesInfo.mainMerchantName=JSON.parse(localStorage.getItem('checkdApply')).applyName;
              this.saveRules(this.rulesInfo).then(()=>{
                  this.$message.success('分账规则保存成功');
                  this.showDialog = false;
                  this.getRulesAll({ mainMerchant: JSON.parse(localStorage.getItem('merchantInfo')).hyUid });
              }).catch((err) => {
                  this.$message.error(err.msg);
              });
            }
            
           
          // }
        }
    //   });
    // },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.item-info {
  .flex_layout(@justify: flex-start);
  span {
    line-height: 20px;
    color: #999;
    margin-left: 20px;
    width: 303px;
  }
}
.table-box {
  margin-left: 70px;
  border: 1px solid #ebeef5;
}
.w-400 {
  width: 400px;
}
.m-l-5 {
  margin-left: 5px !important;
}
.w-200 {
  width: 200px;
}
.add-btn {
  color: #4359b7;
  border-color: #4359b7;
}
.delete-btn {
  color: #ff5f5f;
  font-size: 14px;
  cursor: pointer;
}
.bottom-btn {
  margin: 30px 0 0 70px;
}
</style>
